import React, { useState } from "react";
import About from "../../components/About/About";
import Footer from "../../components/Footer/Footer";
import Hero from "../../components/Hero/Hero";
import Loading from "../../components/Loading/Loading";

const Home = () => {
  const [loading, setLoading] = useState(false);
  setTimeout(() => {
    setLoading(true);
  }, 1900);
  return (
    <div>
      {loading == true ? (
        <>
          <>
            <Hero />
            <About />
            <Footer />
          </>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Home;
